import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class ForecastManagerService {

  environment = EnvironmentService.environment;

  // Subjects
  public forecastGridActionCellSubject: Subject<any> = new Subject();
  // public forecastGridActionDataCellSubject: Subject<any> = new Subject();
  public forecastSetupActionSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setForecastGridActionCellSubject = (value: any) => { this.forecastGridActionCellSubject.next(value); };
  setForecastSetupActionSubject = (value: any) => { this.forecastSetupActionSubject.next(value); };

  // Observables
  getForecastGridActionCellSubject = () => this.forecastGridActionCellSubject.asObservable();
  getForecastSetupActionSubject = () => this.forecastSetupActionSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  ForecastManagerCreateUserSession(params: any) {
    return this.http.post(`${this.environment.ForecastManager}/forecastManagerCreateUserSession`, params)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ForecastManagerDeleteUserSession() {
    return this.http.delete(`${this.environment.ForecastManager}/forecastManagerDeleteUserSession`)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  GetForecastList(obj = {}) {
    return this.http.post(`${this.environment.ForecastManager}/forecastmanagergetlist`, obj)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  forecastManagerGetUserSession(params: any) {
    return this.http.get(`${this.environment.ForecastManager}/forecastManagerGetUserSession`,)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetForecastById(forecastId: any) {
    return this.http.get(`${this.environment.ForecastManager}/getforecastmanagerbyid?forecastId=${forecastId}`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  CreatForecast(body: any) {
    return this.http.post(`${this.environment.ForecastManager}/addforecastmanager`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetForecastHierarchyLevelWithSeasonality(body: any) {
    return this.http.post(`${this.environment.ForecastManager}/GetForecastHierarchyLevelWithSeasonality`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  DeleteForecast(body: any) {
    return this.http.post(`${this.environment.ForecastManager}/deleteForecast`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  CalendarGetList(forecastId: any) {
    return this.http.get(
      `${this.environment.ForecastManager}/getSelectedWeekTimeFrame?forecastId=${forecastId}`).pipe(map((response: any) => {
        return response
      }));
  }

  ExportForecastMatrixTemplate() {
    return this.http.get(
      `${this.environment.ForecastManager}/exportforecastmatrixtemplate`).pipe(map((response: any) => {
        return response
      }));
  }

  ImportForecastMatrixData(body: any, forecastId: any) {

    return this.http.post(`${this.environment.ForecastManager}/importforecastmatrix?forecastId=${forecastId}`, body)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  GetForecastMatrixDataById(forecastId: any) {
    return this.http.get(`${this.environment.ForecastManager}/forecastMatrixGetDataList?forecastId=${forecastId}`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ForecastManagerMatrixDataReset(forecastId: any) {
    return this.http.delete(
      `${this.environment.ForecastManager}/forecastManagerMatrixDataReset?forecastId=${forecastId}`).pipe(map((response: any) => {
        return response
      }));
  }

  ForecastMatrixDataUpdate(body: any) {
    return this.http.put(`${this.environment.ForecastManager}/forecastmatrixdataupdate`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetForecastManagerDataById(forecastId: any) {
    return this.http.get(
      `${this.environment.ForecastManager}/getforecastmanagerdatabyid?forecastId=${forecastId}`).pipe(map((response: any) => {
        return response
      }));
  }

  GetLatestCommitedWeek() {
    return this.http.get(
      `${this.environment.ForecastManager}/LatestCommitedWeekGet`).pipe(map((response: any) => {
        return response
      }));
  }

  // for grid data popup
  // protected listenSubscriptions() {
  //   this.forecastGridActionDataCellSubject.subscribe((data: any) => {
  //     if (data) {
  //       const forecastData = {
  //         forecastData: data.forecastData
  //       };
  //       this.openForecastDataManagerModel(forecastData);
  //     }
  //   });
  // }

  // protected openForecastDataManagerModel(forecastData: any) {
  //   const dialogRef = this.dialog.open(ForecastSeasonalityModalComponent, {
  //     disableClose: true,
  //     panelClass: 'mapping-manager-dialog',
  //     data: {
  //       chartData: forecastData
  //     }
  //   });
  //   dialogRef.afterClosed().subscribe((result: any) => {
  //   });
  // }

}
